import './LiveTypes.sass';

import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import React, { FC, ReactNode, useMemo, useState } from 'react';
import { IcChevron16, IcUsers28 } from '$assets';
import { ReactComponent as IcErotic28 } from './assets/erotic.svg';
import { ReactComponent as IcSponsors28 } from './assets/sponsors.svg';
import { useTranslator } from '$hooks';
import { values } from 'lodash';
import { SelectList } from '$uikit';
import { LiveTypesProps } from '$core/Live/LiveTypes/LiveTypes.Interface';
import { LivePermissionEnum } from '$store/live/interface';

export const LiveTypes: FC<LiveTypesProps> = ({ onTypeChanged, type }) => {
  const t = useTranslator();

  const STREAM_TYPES = useMemo<{
    [key in LivePermissionEnum]: {
      value: LivePermissionEnum;
      icon: ReactNode;
      label: string;
      desc: string;
    };
  }>(
    () => ({
      public: {
        value: LivePermissionEnum.PUBLIC,
        label: t('live_type_public_title'),
        desc: t('live_type_public_desc'),
        icon: <IcUsers28 />,
      },
      erotic: {
        value: LivePermissionEnum.EROTIC,
        label: t('live_type_erotic_and_sponsors_title'),
        desc: t('live_type_erotic_and_sponsors_desc'),
        icon: <IcErotic28 />,
      },
      sponsor: {
        value: LivePermissionEnum.SPONSOR,
        label: t('live_type_sponsors_title'),
        desc: t('live_type_sponsors_desc'),
        icon: <IcSponsors28 />,
      },
    }),
    [t],
  );

  const [bottomSheetIsVisible, setBottomSheetIsVisible] = useState(false);

  const handleBottomSheetOpen = () => {
    setBottomSheetIsVisible(true);
  };
  const handleBottomSheetClose = () => {
    setBottomSheetIsVisible(false);
  };
  const handleBottomSheetTypeClick = (type: LivePermissionEnum) => {
    onTypeChanged(type);
    setBottomSheetIsVisible(false);
  };

  const curType = STREAM_TYPES[type];

  return (
    <div className="LiveTypes">
      <div className="LiveTypes__type" onClick={handleBottomSheetOpen}>
        <div className="LiveTypes__type__head">
          {curType.icon}
          <span className="LiveTypes__type__title">{curType.label}</span>
        </div>
        <div className="LiveTypes__desc">{curType.desc}</div>
        <div className="LiveTypes__chevron">
          <IcChevron16 />
        </div>
      </div>
      {bottomSheetIsVisible && (
        <BottomSheet
          className="LiveTypes__bottomSheet"
          title={t('live_type_bottom_sheet_title')}
          scroll={true}
          onClose={handleBottomSheetClose}
        >
          <SelectList
            value={[type]}
            options={values(STREAM_TYPES)}
            onChange={([name]) => handleBottomSheetTypeClick(name)}
          />
        </BottomSheet>
      )}
    </div>
  );
};
